import { createTheme, createVariant, globalTheme } from '@cld/component-theme';
import { ItemStyleProps, SupportedLayoutTypographySize } from './types';

const supportedSize = (size: SupportedLayoutTypographySize) => size;

export const itemTheme = createTheme(
  {
    layout: {
      normal: {
        sizeVariant: {
          sm: {
            slotSize: 'md',
            horizontalMargin: globalTheme.spacing.sm,
            slotVerticalMargin: globalTheme.spacing.xs,
          },
          md: {
            slotSize: 'md',
            horizontalMargin: globalTheme.spacing.sm,
            slotVerticalMargin: globalTheme.spacing.sm,
          },
          lg: {
            slotSize: 'lg',
            horizontalMargin: globalTheme.spacing.sm,
            slotVerticalMargin: globalTheme.spacing.md,
          },
        },
        oneliner: {
          sm: {
            verticalMargin: globalTheme.spacing.xs,
            typographySize: supportedSize('xs'),
          },
          md: {
            verticalMargin: globalTheme.spacing.sm,
            typographySize: supportedSize('sm'),
          },
          lg: {
            verticalMargin: globalTheme.spacing.md,
            typographySize: supportedSize('md'),
          },
        },
        twoliner: {
          sm: {
            gap: '0',
            verticalMargin: globalTheme.spacing.xxs,
            typographySize: {
              line1: supportedSize('xxs'),
              line2: supportedSize('xxs'),
            },
          },
          md: {
            gap: '0.125rem',
            verticalMargin: globalTheme.spacing.xxs,
            typographySize: {
              line1: supportedSize('xs'),
              line2: supportedSize('xxs'),
            },
          },
          lg: {
            gap: globalTheme.spacing.xxs,
            verticalMargin: globalTheme.spacing.xs,
            typographySize: {
              line1: supportedSize('sm'),
              line2: supportedSize('xxs'),
            },
          },
        },
      },
    },
  },
  'item'
);

export type ItemThemeProps = Required<Pick<ItemStyleProps, 'size'>>;

const normalTheme = itemTheme.layout.normal;

export const itemLayoutSizeVariant = createVariant((props: ItemThemeProps) => normalTheme.sizeVariant[props.size]);
export const onelinerSizeVariant = createVariant((props: ItemThemeProps) => normalTheme.oneliner[props.size]);
export const twolinerSizeVariant = createVariant((props: ItemThemeProps) => normalTheme.twoliner[props.size]);
